import { filterTableConfig } from "@/config/filter-table-config";

export const tasksConfig = {
  itemsPerPageOptions: filterTableConfig.itemsPerPageOptionsSmall,
};
